import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onUnmounted } from 'vue';
import { ArrowLeftBold, ArrowRightBold } from '@element-plus/icons-vue';
import { BaseIcon } from 'xrk-components';


export default /*#__PURE__*/_defineComponent({
  __name: 'Carousel',
  setup(__props) {

const carouselBody = ref<HTMLDivElement>();
const count = ref(0);
const activeIndex = ref(0);
const isEnd = ref(false);
const isScroll = ref(false);

onMounted(() => {
  initItemStyle();
});
onUnmounted(() => {
  carouselBody.value?.removeEventListener('scroll', moveStart);
  carouselBody.value?.removeEventListener('scrollend', moveEnd);
});
const moveStart = () => (isScroll.value = true);
const moveEnd = () => (isScroll.value = false);
const initItemStyle = () => {
  count.value = carouselBody.value.children.length;
  carouselBody.value.addEventListener('scroll', moveStart);
  carouselBody.value.addEventListener('scrollend', moveEnd);
};

const move = async () => {
  return new Promise((resolve, reject) => {
    const firstDomLeft =
      carouselBody.value.children[0].getBoundingClientRect().left;
    carouselBody.value.scrollTo({
      left: (carouselBody.value.children[activeIndex.value] as HTMLDivElement)
        .offsetLeft,
      behavior: 'smooth'
    });
    setTimeout(() => {
      if (
        firstDomLeft ===
        carouselBody.value.children[0].getBoundingClientRect().left
      ) {
        reject('未移动');
      }
      resolve('移动成功');
    }, 300);
  });
};

const next = async (event?: Event) => {
  event?.preventDefault();
  if (isEnd.value || isScroll.value || activeIndex.value == count.value - 1)
    return;
  activeIndex.value += 1;
  try {
    await move();
  } catch (error) {
    console.log(error);
    next();
  }
};

const prev = async (event?: Event) => {
  event?.preventDefault();
  if (isScroll.value || activeIndex.value == 0) return;
  activeIndex.value -= 1;
  try {
    await move();
  } catch (error) {
    console.log(error);
    prev();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ '--count': count.value }),
    class: "carousel"
  }, [
    _createElementVNode("div", {
      ref_key: "carouselBody",
      ref: carouselBody,
      class: "carousel-body"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 512),
    _createElementVNode("button", {
      class: "carousel-prev",
      onClick: prev
    }, [
      _createVNode(_unref(BaseIcon), null, {
        default: _withCtx(() => [
          _createVNode(_unref(ArrowLeftBold))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("button", {
      class: "carousel-next",
      onClick: next
    }, [
      _createVNode(_unref(BaseIcon), null, {
        default: _withCtx(() => [
          _createVNode(_unref(ArrowRightBold))
        ]),
        _: 1
      })
    ])
  ], 4))
}
}

})